import {filter} from 'rxjs/operators';
import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import {SidebarHelper} from './helpers/SidebarHelper';
import {Globals} from '../../models/Globals';
import {NavigationEnd, Router} from '@angular/router';
import {UserService} from '../../features/auth/services/user.service';
import {NavigationService} from '../../../../utils/NavigationService/navigation.service';

// TODO: Reactivar chat en un futuro
// declare var QB: any;

// Metadata
export interface RouteInfo {
  id: string;
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  children?: ChildrenItems[];
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab: string;
  type?: string;
}

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit, AfterViewInit {

  // Menu Items
  public menuItems: any[];
  private sidebarHelper: SidebarHelper;

  constructor(sidebarHelper: SidebarHelper,
              private router: Router,
              public globals: Globals,
              private userService: UserService,
              private navigationService: NavigationService) {
    this.sidebarHelper = sidebarHelper;
  }

  // Desktop rail with only icons: each option shows its name in a tooltip (hover and keyboard focus).
  get collapsed(): boolean {
    return document.body.classList.contains('sidebar-mini') && window.matchMedia('(min-width: 992px)').matches;
  }

  get myAccountRoute(): string {
    return this.sidebarHelper.getMyAccountRoute(this.globals.customerType);
  }

  ngOnInit() {
    this.menuItems = this.sidebarHelper.getRoutes(this.globals.customerType).filter(menuItem => menuItem);
    this.setRouterAndSidebarGestion();
  }

  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
      const ps = new PerfectScrollbar(elemSidebar, {wheelSpeed: 2, suppressScrollX: true});
    }
  }

  isMac(): boolean {
    let isMac = false;
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0
      || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
      isMac = true;
    }
    return isMac;
  }

  setMyShipmentsActive() {
    try {
      document.getElementById("my-shipments-tab").classList.add('active');
    } catch (e) {
      // Do nothing
    }
  }

  setMyShipmentsInActive() {
    try {
      document.getElementById("my-shipments-tab").classList.remove('active');
    } catch (e) {
      // Do nothing
    }
  }

  setRouterAndSidebarGestion() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (!this.isMyShipmentsLink()) {
        this.setMyShipmentsInActive();
      } else {
        setTimeout(this.setMyShipmentsActive, 50);
      }
    });
  }

  isMyShipmentsLink() {
    const bool = this.router.url.includes('/company-shipment-detail')
      || this.router.url.includes('/forwarder-shipment-detail')
      || this.router.url.includes('/forwarder-shipments')
      || this.router.url.includes('/company-shipments');
    return bool;
  }

  ngAfterViewInit(): void {
    if (this.isMyShipmentsLink()) {
      this.setMyShipmentsActive();
    }
  }

  logoutChatQB() {
    // TODO: Reactivar chat en un futuro
    /*
    try {
      QB.chat.disconnect();
    } catch (e) {

    }*/
  }

  lock(): void {
    this.userService.lock();
  }

  signOut(): void {
    this.navigationService.reset();
    this.userService.logout();
  }
}
